if (!customElements.get('s2400-scene-overview')) {
  customElements.define('s2400-scene-overview', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      this.abort = new AbortController();
      this.animations = [];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const { signal } = this.abort;
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-scene-anchor]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const destination = new URL(link.href, location.href);
        if (destination.origin !== location.origin || destination.pathname !== location.pathname || !destination.hash) return;
        const target = document.getElementById(decodeURIComponent(destination.hash.slice(1)));
        if (!target) return;
        event.preventDefault();
        const inset = Array.from(document.querySelectorAll('.shopify-section-header, sticky-header, .sunpura-anchor, .sunpura-anchor__bar')).reduce((max, node) => {
          const rect = node.getBoundingClientRect(), style = getComputedStyle(node);
          return ['fixed', 'sticky'].includes(style.position) && rect.top < 180 && rect.bottom > 0 ? Math.max(max, rect.bottom) : max;
        }, 0);
        window.scrollTo({ top: Math.max(0, scrollY + target.getBoundingClientRect().top - Math.max(inset, 140) - 20), behavior: this.motion.matches || this.dataset.motion !== 'true' ? 'instant' : 'smooth' });
        const heading = target.querySelector('h2, h3') || target;
        if (!heading.hasAttribute('tabindex')) {
          heading.setAttribute('tabindex', '-1');
          heading.addEventListener('blur', () => heading.removeAttribute('tabindex'), { once: true });
        }
        history.replaceState(null, '', link.hash);
        heading.focus({ preventScroll: true });
      }, { signal });
      if (this.dataset.motion === 'true' && !this.motion.matches && 'IntersectionObserver' in window) {
        const revealTargets = [
          [this.querySelector('.sp-scene__headline'), 'headline'],
          [this.querySelector('.sp-benefits__header'), 'headline'],
          ...Array.from(this.querySelectorAll('.sp-benefit')).map(card => [card, 'card'])
        ].filter(([node]) => node);
        revealTargets.forEach(([node, kind]) => { node.dataset.sceneReveal = kind; });
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            this.observer.unobserve(entry.target);
            if (this.motion.matches || !entry.target.animate) continue;
            const kind = entry.target.dataset.sceneReveal;
            const animation = kind === 'headline'
              ? entry.target.animate(
                  [{ opacity: .82, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }],
                  { duration: 360, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'both' }
                )
              : entry.target.animate(
                    [{ opacity: .7, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }],
                    { duration: 320, easing: 'ease-out', fill: 'both' }
                  );
            this.animations.push(animation);
          }
        }, { threshold: .1 });
        revealTargets.forEach(([node]) => this.observer.observe(node));
      }
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.animations.forEach(animation => animation.cancel());
      }, { signal });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
    }
  });
}
